export default __webpack_public_path__ + "static/media/gallery_01.d2b344d2.jpg";